import { Reports } from "@stories/pages/Contractor/Reports/Reports";

export const ReportView = () => {
  return <Reports />;
};
